import React, { Component, PureComponent } from "react";
import PropTypes from "prop-types";
import { StyleSheet, View, Image, Platform } from "react-native";
import _ from "lodash";
import { ViewPropTypes, ImagePropTypes } from "deprecated-react-native-prop-types";
import DebugLogger from "../../utils/DebugLogger";
import localStorageFileHelper from "../../utils/LocalStorageFileHelper";
import * as WebHelper from "../utils/WebHelper";
import MessageBox from "../components/ui/MessageBox";
// import resolveAssetSource from "react-native/Libraries/Image/resolveAssetSource";
// import TextTrackType from "./TextTrackType";
// import FilterType from "./FilterType";
// import DRMType from "./DRMType";
// import VideoResizeMode from "./VideoResizeMode.js";

const styles = StyleSheet.create({
    base: {
        overflow: "hidden",
    },
});

class Video extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPoster: !!props.poster,
            src: null,
            srcSource: null,
            isUrlObject: false,
        };
    }

    toTypeString(x) {
        switch (typeof x) {
            case "object":
                return x instanceof Date ? x.toISOString() : JSON.stringify(x); // object, null
            case "undefined":
                return "";
            default:
                // boolean, number, string
                return x.toString();
        }
    }

    stringsOnlyObject(obj) {
        const strObj = {};

        Object.keys(obj).forEach(x => {
            strObj[x] = this.toTypeString(obj[x]);
        });

        return strObj;
    }

    _setupRoot = ref => {
        this._root = ref;
        if (this._root && this.props.rate !== undefined) {
            this._root.defaultPlaybackRate = this.props.rate;
            this._root.playbackRate = this.props.rate;
        }
    };

    seek = (time, tolerance = 100) => {
        this._root.currentTime = time;
    };

    presentFullscreenPlayer = () => {
        this.setNativeProps({ fullscreen: true });
    };

    dismissFullscreenPlayer = () => {
        this.setNativeProps({ fullscreen: false });
    };

    save = options => {};

    restoreUserInterfaceForPictureInPictureStopCompleted = restored => {
        this.setNativeProps({ restoreUserInterfaceForPIPStopCompletionHandler: restored });
    };

    _hidePoster = () => {
        if (this.state.showPoster) {
            this.setState({ showPoster: false });
        }
    };

    _onLoadStart = event => {
        if (this.props.onLoadStart) {
            this.props.onLoadStart(event.nativeEvent);
        }
    };

    _onPlaybackStateChanged = event => {
        if (this.props.onPlaybackStateChanged) {
            this.props.onPlaybackStateChanged(event.nativeEvent);
        }
    };

    _onLoad = event => {
        // Need to hide poster here for windows as onReadyForDisplay is not implemented
        if (Platform.OS === "web") {
            this._hidePoster();
        }
        if (this.props.onLoad) {
            this.props.onLoad({ duration: this._root.duration });
        }
    };

    _onError = event => {
        if (this.props.onError) {
            this.props.onError(event.nativeEvent);
        }
    };

    _onProgress = event => {
        if (this.props.onProgress) {
            this.props.onProgress(event.nativeEvent);
        }
    };

    _onBandwidthUpdate = event => {
        if (this.props.onBandwidthUpdate) {
            this.props.onBandwidthUpdate(event.nativeEvent);
        }
    };

    _onSeek = event => {
        if (this.props.onSeek) {
            this.props.onSeek(event.nativeEvent);
        }
    };

    _onEnd = event => {
        if (this.props.onEnd) {
            this.props.onEnd(event.nativeEvent);
        }
    };

    _onTimedMetadata = event => {
        if (this.props.onTimedMetadata) {
            this.props.onTimedMetadata(event.nativeEvent);
        }
    };

    _onFullscreenPlayerWillPresent = event => {
        if (this.props.onFullscreenPlayerWillPresent) {
            this.props.onFullscreenPlayerWillPresent(event.nativeEvent);
        }
    };

    _onFullscreenPlayerDidPresent = event => {
        if (this.props.onFullscreenPlayerDidPresent) {
            this.props.onFullscreenPlayerDidPresent(event.nativeEvent);
        }
    };

    _onFullscreenPlayerWillDismiss = event => {
        if (this.props.onFullscreenPlayerWillDismiss) {
            this.props.onFullscreenPlayerWillDismiss(event.nativeEvent);
        }
    };

    _onFullscreenPlayerDidDismiss = event => {
        if (this.props.onFullscreenPlayerDidDismiss) {
            this.props.onFullscreenPlayerDidDismiss(event.nativeEvent);
        }
    };

    _onReadyForDisplay = event => {
        if (!this.props.audioOnly) {
            this._hidePoster();
        }

        if (this.props.onReadyForDisplay) {
            this.props.onReadyForDisplay(event.nativeEvent);
        }
    };

    _onPlaybackStalled = event => {
        if (this.props.onPlaybackStalled) {
            this.props.onPlaybackStalled(event.nativeEvent);
        }
    };

    _onPlaybackResume = event => {
        if (this.props.onPlaybackResume) {
            this.props.onPlaybackResume(event.nativeEvent);
        }
    };

    _onPlaybackRateChange = event => {
        if (this.props.onPlaybackRateChange) {
            this.props.onPlaybackRateChange(event.nativeEvent);
        }
    };

    _onExternalPlaybackChange = event => {
        if (this.props.onExternalPlaybackChange) {
            this.props.onExternalPlaybackChange(event.nativeEvent);
        }
    };

    _onAudioBecomingNoisy = () => {
        if (this.props.onAudioBecomingNoisy) {
            this.props.onAudioBecomingNoisy();
        }
    };

    _onPictureInPictureStatusChanged = event => {
        if (this.props.onPictureInPictureStatusChanged) {
            this.props.onPictureInPictureStatusChanged(event.nativeEvent);
        }
    };

    _onRestoreUserInterfaceForPictureInPictureStop = event => {
        if (this.props.onRestoreUserInterfaceForPictureInPictureStop) {
            this.props.onRestoreUserInterfaceForPictureInPictureStop();
        }
    };

    _onAudioFocusChanged = event => {
        if (this.props.onAudioFocusChanged) {
            this.props.onAudioFocusChanged(event.nativeEvent);
        }
    };

    _onBuffer = event => {
        if (this.props.onBuffer) {
            this.props.onBuffer(event.nativeEvent);
        }
    };

    _generateSource = props => {
        return new Promise((reslove, reject) => {
            const setUri = (uri, srcSource, isUrlObject) => {
                const previousSrc = this.state.srcSource;
                if (!_.isEqual(previousSrc, srcSource)) {
                    const preSrc = this.state.src;
                    const preIsUrlObject = this.state.src;

                    this.setState(
                        {
                            src: uri,
                            srcSource: srcSource,
                            isUrlObject: isUrlObject,
                        },
                        () => {
                            if (preIsUrlObject) {
                                try {
                                    window.URL.revokeObjectURL(preSrc);
                                } catch (e) {
                                    console.error(e);
                                }
                            }
                            reslove();
                        }
                    );
                }
            };
            const source = props.source || {};

            let uri = source.uri || "";
            if (uri === "" && _.isString(props.source)) {
                uri = props.source;
            }

            if (uri instanceof File) {
                uri = window.URL.createObjectURL(uri);
            }

            if (_.isString(uri) && _.startsWith(uri, "/")) {
                localStorageFileHelper
                    .getFile(uri)
                    .then(filez => {
                        let fileUri = uri;
                        let fileSource = uri;
                        let isUrlObject = false;
                        if (filez instanceof File) {
                            fileUri = window.URL.createObjectURL(filez);
                            isUrlObject = true;
                        }

                        setUri(fileUri, fileSource, isUrlObject);
                    })
                    .catch(e => {
                        console.error(e);
                        reject(e);
                    });
            } else {
                setUri(uri, uri, false);
            }
        });
    };

    componentDidMount() {
        this._generateSource(this.props).then(() => {
            if (this._root) {
                try {
                    if (this.props.paused) {
                        this._handlePlayPromise(this._root.pause());
                    } else if (this.state.src !== "" && this.state.src) {
                        this._handlePlayPromise(this._root.play());
                    }
                } catch (e) {
                    DebugLogger.log(e);
                }
            }
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //  if (prevProps.muted !== this.props.muted) {
        //     if (this._root) {
        //        this._root.muted = this.props.muted;
        //     }
        // }

        if (prevProps.rate !== this.props.rate) {
            if (this._root) {
                this._root.defaultPlaybackRate = this.props.rate;
                this._root.playbackRate = this.props.rate;
            }
        }

        if (prevProps.source !== this.props.source) {
            if (prevProps.source && this.props.source && (prevProps.source.uri === this.props.source.uri)) {
            } else {
                this._generateSource(this.props).then(() => {
                    if (this._root) {
                        try {
                            if (this.props.paused) {
                                this._handlePlayPromise(this._root.pause());
                            } else {
                                this._handlePlayPromise(this._root.play());
                            }
                        } catch (e) {
                            DebugLogger.log(e);
                        }
                    }
                });
            }
        }

        if (prevProps.paused !== this.props.paused) {
            if (this._root) {
                try {
                    if (this.props.paused) {
                        this._handlePlayPromise(this._root.pause());
                    } else if (this.state.src !== "" && this.state.src) {
                        this._handlePlayPromise(this._root.play());
                    }
                } catch (e) {
                    DebugLogger.log(e);
                }
            }
        }
    }

    render() {
        const resizeMode = this.props.resizeMode;

        let nativeResizeMode;

        const nativeProps = { style: this.props.style, muted: this.props.muted, rate: this.props.rate };
        //Object.assign({}, this.props);
        Object.assign(nativeProps, {
            style: [styles.base, nativeProps.style],
            //resizeMode: nativeResizeMode,
            // src: {
            //     uri,
            //     isNetwork,
            //     isAsset,
            //     shouldCache,
            //     type: source.type || "",
            //     mainVer: source.mainVer || 0,
            //     patchVer: source.patchVer || 0,
            //     requestHeaders: source.headers ? this.stringsOnlyObject(source.headers) : {},
            // },
            src: this.props.src,
            onLoadStart: this._onLoadStart,
            // onVideoPlaybackStateChanged: this._onPlaybackStateChanged,
            //onLoadedData: this._onLoad,
            //onDurationChange: this._onLoad,
            onError: this._onError,
            onProgress: this._onProgress,
            onSeeking: this._onSeek,
            onEnded: this._onEnd,
            // onVideoBuffer: this._onBuffer,
            // onVideoBandwidthUpdate: this._onBandwidthUpdate,
            onLoadedMetadata: this._onTimedMetadata,
            // onVideoAudioBecomingNoisy: this._onAudioBecomingNoisy,
            // onVideoExternalPlaybackChange: this._onExternalPlaybackChange,
            // onVideoFullscreenPlayerWillPresent: this._onFullscreenPlayerWillPresent,
            // onVideoFullscreenPlayerDidPresent: this._onFullscreenPlayerDidPresent,
            // onVideoFullscreenPlayerWillDismiss: this._onFullscreenPlayerWillDismiss,
            // onVideoFullscreenPlayerDidDismiss: this._onFullscreenPlayerDidDismiss,
            onCanPlay: this._onReadyForDisplay,
            // onPlaybackStalled: this._onPlaybackStalled,
            // onPlaybackResume: this._onPlaybackResume,
            // onPlaybackRateChange: this._onPlaybackRateChange,
            // onAudioFocusChanged: this._onAudioFocusChanged,
            // onAudioBecomingNoisy: this._onAudioBecomingNoisy,
            // onPictureInPictureStatusChanged: this._onPictureInPictureStatusChanged,
            // onRestoreUserInterfaceForPictureInPictureStop: this._onRestoreUserInterfaceForPictureInPictureStop,
        });

        const posterStyle = {
            ...StyleSheet.absoluteFillObject,
            resizeMode: this.props.posterResizeMode || "contain",
        };

        if (WebHelper.isSafari()) {
            // iPhone的safari不会触发onLoadedData?
            nativeProps.onDurationChange = this._onLoad;
        } else {
            nativeProps.onLoadedData = this._onLoad;
        }
        return (
            <View style={nativeProps.style}>
                {this.props.audioOnly ? <audio preload="true" ref={this._setupRoot} {...nativeProps} style={StyleSheet.absoluteFill} src={this.state.src} /> : null}
                {this.state.showPoster && <Image style={posterStyle} source={{ uri: this.props.poster }} />}
            </View>
        );
    }

    _handlePlayPromise = playPromise => {
        // In browsers that don’t yet support this functionality,
        // playPromise won’t be defined.
        if (playPromise !== undefined) {
            playPromise
                .then(function() {
                    // Automatic playback started!
                })
                .catch(function(error) {
                    // Automatic playback failed.
                    // Show a UI element to let the user manually start playback.
                    DebugLogger.log(error);
                    /*
                    MessageBox.danger({
                        text: error.message,
                        position: "top",
                        duration: 5000
                    });
                    */
                });
        }
    };
}

Video.propTypes = {
    filterEnabled: PropTypes.bool,
    /* Native only */
    src: PropTypes.object,
    seek: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    fullscreen: PropTypes.bool,
    onVideoLoadStart: PropTypes.func,
    onVideoLoad: PropTypes.func,
    onVideoBuffer: PropTypes.func,
    onVideoError: PropTypes.func,
    onVideoProgress: PropTypes.func,
    onVideoBandwidthUpdate: PropTypes.func,
    onVideoSeek: PropTypes.func,
    onVideoEnd: PropTypes.func,
    onTimedMetadata: PropTypes.func,
    onVideoAudioBecomingNoisy: PropTypes.func,
    onVideoExternalPlaybackChange: PropTypes.func,
    onVideoFullscreenPlayerWillPresent: PropTypes.func,
    onVideoFullscreenPlayerDidPresent: PropTypes.func,
    onVideoFullscreenPlayerWillDismiss: PropTypes.func,
    onVideoFullscreenPlayerDidDismiss: PropTypes.func,

    /* Wrapper component */
    source: PropTypes.oneOfType([
        PropTypes.shape({
            uri: PropTypes.string,
        }),
        // Opaque type returned by require('./video.mp4')
        PropTypes.number,
        PropTypes.string,
        PropTypes.object,
    ]),
    localSourceEncryptionKeyScheme: PropTypes.string,
    minLoadRetryCount: PropTypes.number,
    maxBitRate: PropTypes.number,
    resizeMode: PropTypes.string,
    poster: PropTypes.string,
    posterResizeMode: ImagePropTypes.resizeMode,
    repeat: PropTypes.bool,
    automaticallyWaitsToMinimizeStalling: PropTypes.bool,
    allowsExternalPlayback: PropTypes.bool,
    selectedAudioTrack: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    selectedVideoTrack: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    selectedTextTrack: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    paused: PropTypes.bool,
    muted: PropTypes.bool,
    volume: PropTypes.number,
    bufferConfig: PropTypes.shape({
        minBufferMs: PropTypes.number,
        maxBufferMs: PropTypes.number,
        bufferForPlaybackMs: PropTypes.number,
        bufferForPlaybackAfterRebufferMs: PropTypes.number,
        maxHeapAllocationPercent: PropTypes.number,
    }),
    rate: PropTypes.number,
    pictureInPicture: PropTypes.bool,
    playInBackground: PropTypes.bool,
    preferredForwardBufferDuration: PropTypes.number,
    playWhenInactive: PropTypes.bool,
    ignoreSilentSwitch: PropTypes.oneOf(["ignore", "obey"]),
    reportBandwidth: PropTypes.bool,
    contentStartTime: PropTypes.number,
    disableFocus: PropTypes.bool,
    disableBuffering: PropTypes.bool,
    controls: PropTypes.bool,
    audioOnly: PropTypes.bool,
    currentTime: PropTypes.number,
    fullscreenAutorotate: PropTypes.bool,
    fullscreenOrientation: PropTypes.oneOf(["all", "landscape", "portrait"]),
    progressUpdateInterval: PropTypes.number,
    subtitleStyle: PropTypes.shape({
        paddingTop: PropTypes.number,
        paddingBottom: PropTypes.number,
        paddingLeft: PropTypes.number,
        paddingRight: PropTypes.number,
        fontSize: PropTypes.number,
    }),
    useTextureView: PropTypes.bool,
    useSecureView: PropTypes.bool,
    hideShutterView: PropTypes.bool,
    onLoadStart: PropTypes.func,
    onPlaybackStateChanged: PropTypes.func,
    onLoad: PropTypes.func,
    onBuffer: PropTypes.func,
    onError: PropTypes.func,
    onProgress: PropTypes.func,
    onBandwidthUpdate: PropTypes.func,
    onSeek: PropTypes.func,
    onEnd: PropTypes.func,
    onFullscreenPlayerWillPresent: PropTypes.func,
    onFullscreenPlayerDidPresent: PropTypes.func,
    onFullscreenPlayerWillDismiss: PropTypes.func,
    onFullscreenPlayerDidDismiss: PropTypes.func,
    onReadyForDisplay: PropTypes.func,
    onPlaybackStalled: PropTypes.func,
    onPlaybackResume: PropTypes.func,
    onPlaybackRateChange: PropTypes.func,
    onAudioFocusChanged: PropTypes.func,
    onAudioBecomingNoisy: PropTypes.func,
    onPictureInPictureStatusChanged: PropTypes.func,
    needsToRestoreUserInterfaceForPictureInPictureStop: PropTypes.func,
    onExternalPlaybackChange: PropTypes.func,

    /* Required by react-native */
    scaleX: PropTypes.number,
    scaleY: PropTypes.number,
    translateX: PropTypes.number,
    translateY: PropTypes.number,
    rotation: PropTypes.number,
    ...ViewPropTypes,
};

export default Video;
